// extracted by mini-css-extract-plugin
export default {"multiple-choice":"multipleChoice_multiple-choice__C71JV","options":"multipleChoice_options__ZBLzY"};